/* global wx */
import axios from "axios";

/**
 * 配置微信分享
 * @param {Object} shareConfig 分享配置
 * @param {string} shareConfig.title 分享标题
 * @param {string} shareConfig.desc 分享描述
 * @param {string} shareConfig.link 分享链接
 * @param {string} shareConfig.imgUrl 分享图标
 */
export const configWechatShare = async shareConfig => {
  try {
    // 获取微信配置
    const response = await axios.get(`/recruitcenter/wechat/share`, {
      params: {
        appName: "sfzp",
        url: encodeURIComponent(window.location.href.split("#")[0])
      }
    });

    const config = response.result;
    console.log("获取微信配置", config);

    // 配置微信JS-SDK
    wx.config({
      debug: false,
      appId: config.appId,
      timestamp: config.timestamp,
      nonceStr: config.nonceStr,
      signature: config.signature,
      jsApiList: [
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "onMenuShareAppMessage",
        "onMenuShareTimeline"
      ]
    });

    // wx.config 校验失败时 wx.ready 依然会执行（jweixin 内部 _completes 在 complete 回调中被无条件清空），
    // 不注册 wx.error 会导致真正的 config:fail 原因被吞掉，
    // 只能在分享接口的 fail 回调里看到 "the permission value is offline verifying"
    wx.error(err => {
      console.error("wx.config 校验失败:", err);
    });

    wx.ready(() => {
      // 现代浏览器接口
      if (wx.updateAppMessageShareData) {
        wx.updateAppMessageShareData({
          title: shareConfig.title, // 分享标题
          desc: shareConfig.desc, // 分享描述
          link: shareConfig.link, // 分享链接
          imgUrl: shareConfig.imgUrl, // 分享图标
          success: function() {
            console.log("分享配置成功");
          },
          fail: function(error) {
            console.error("分享配置失败:", error);
          }
        });
      }

      // 朋友圈分享
      if (wx.updateTimelineShareData) {
        wx.updateTimelineShareData({
          title: shareConfig.title, // 分享标题
          link: shareConfig.link, // 分享链接
          imgUrl: shareConfig.imgUrl, // 分享图标
          success: function() {
            console.log("朋友圈分享配置成功");
          }
        });
      }

      // 兼容低版本微信
      wx.onMenuShareAppMessage({
        title: shareConfig.title,
        desc: shareConfig.desc,
        link: shareConfig.link,
        imgUrl: shareConfig.imgUrl,
        success: function() {
          console.log("分享给朋友配置成功");
        }
      });

      wx.onMenuShareTimeline({
        title: shareConfig.title,
        link: shareConfig.link,
        imgUrl: shareConfig.imgUrl,
        success: function() {
          console.log("分享到朋友圈配置成功");
        }
      });
    });
  } catch (error) {
    console.error("获取微信配置失败:", error);
  }
};



// WEBPACK FOOTER //
// ./src/utils/wechatShare.js